interface LogoProps {
  /** Pixel size (width) of the logo. Height follows the 1:1 aspect ratio. */
  size?: number
  className?: string
}

/**
 * Jordan Draper Games logo — the official lime-green wordmark PNG
 * pulled from jordandraper.com.
 *
 * Replaces the old SVG text approximation with the real asset
 * so the logo renders identically regardless of which fonts are loaded.
 */
export function Logo({ size = 128, className }: LogoProps) {
  return (
    <img
      src="/jdg-logo.webp"
      alt="Jordan Draper Games"
      width={size}
      height={size}
      draggable={false}
      className={className}
    />
  )
}
